import { render } from "./HeaderComponent.vue?vue&type=template&id=55046ace&scoped=true"
import script from "./HeaderComponent.vue?vue&type=script&lang=js"
export * from "./HeaderComponent.vue?vue&type=script&lang=js"

import "./HeaderComponent.vue?vue&type=style&index=0&id=55046ace&scoped=true&lang=css"

import exportComponent from "C:\\Users\\dvdsa\\projects\\avante-pwa\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55046ace"]])

export default __exports__